import _globalThis from "@babel/runtime-corejs3/core-js/global-this";

/* eslint-disable no-undef, no-restricted-globals */
var globalObject = function () {
  // new standardized access to the global object
  if (typeof _globalThis !== 'undefined') {
    return _globalThis;
  } // WebWorker specific access


  if (typeof self !== 'undefined') {
    return self;
  }

  return window;
}();

var btoa = globalObject.btoa;
export default btoa;